import { cn } from "@/lib/utils";

export default function StepIndicator({ steps, current }) {
  return (
    <div
      data-testid="step-indicator"
      className="flex items-center gap-5 flex-wrap"
    >
      {steps.map((label, idx) => {
        const isActive = idx === current;
        const isDone = idx < current;
        return (
          <div
            key={label}
            data-testid={`step-${idx}`}
            className="flex items-center gap-3"
          >
            <span
              className={cn(
                "inline-block w-1.5 h-1.5 rounded-none transition-colors",
                isActive
                  ? "bg-[#B0895C]"
                  : isDone
                    ? "bg-[#C03028]"
                    : "bg-[#E3DED5]"
              )}
            />
            <span
              className={cn(
                "text-[10px] uppercase tracking-[0.22em] font-semibold transition-colors",
                isActive
                  ? "text-[#2A1F1A]"
                  : isDone
                    ? "text-[#C03028]"
                    : "text-[#6E6E70]/60"
              )}
            >
              {`0${idx + 1}`} · {label}
            </span>
          </div>
        );
      })}
    </div>
  );
}
